import React, { Component } from 'react';
import './ImageViewer.css';
import ParameterErrors from '../errors/ParameterErrors';
import MenuType from '../enums/MenuType';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import SubMenuHeader from './SubMenuHeader';
const  {throwNotProvided, throwNotOfType} = ParameterErrors;
export default class PrivacyPolicy extends Component {
	constructor(props){
		super(props)
		this._iMenuManager  = null;
		this._clickedOffHandle = null;
		this._elementRef = React.createRef();
		this._sliderRef = React.createRef();
		this._subMenuHeaderRef = React.createRef();
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this._clickedOffManager = new ClickedOffManager({elementRef:this._elementRef, hide:this.hide});
		this.state={visible:false};
	}
	get menuType(){
		return MenuType.PRIVACY_POLICY;
	}
	show(){
		this.setState({visible:true});
		this._clickedOffManager.register();
		this._iMenuManager.showMe(this);
	}
	hide(){
		this._clickedOffManager.dispose();
		this.setState({visible:false});
		this._iMenuManager.close();
	}
	setIMenuManager(value){
		this._iMenuManager = value;
		this._subMenuHeaderRef.current.setIMenuManager(value);
	}
	render() {
		let className ="privacy-policy menu";
		if(this.state.visible)
			className+=" visible";
		return (<div className={className} onClick={this._handleClick} ref={this._elementRef}>
				<SubMenuHeader ref={this._subMenuHeaderRef} title="Privacy Policy"></SubMenuHeader>
				<div className="text-wrapper" ref={this._pictureWrapperRef}>
					This is a privacy policy to go here!
				</div>
			</div>);
	}
}
